export const SITE = {
  name: "NEXORA Web Studio",
  url: "https://nexora-web-design.base44.app",
  heroImage:
    "https://cdn.magicpatterns.com/patterns/generated-images/f3a617d1-4d65-4d14-8e01-79141ef333be.jpg",
  ogImage:
    "https://cdn.magicpatterns.com/patterns/generated-images/644cd64c-be5a-40f3-af2c-eef257928d19.jpg",
  demoImage:
    "https://cdn.magicpatterns.com/patterns/generated-images/cd277cd5-53f2-44c5-a533-f9cb6da9dae5.jpg",
};

export const CONTACT = {
  email: "webstudiosn@gmail.com",
  phones: [
    { label: "(702) 521-3889", href: "tel:+17025213889" },
    { label: "(702) 802-8436", href: "tel:+17028028436" },
  ],
  hours: "Business hours — placeholder (to be confirmed)",
};

export const PRICING = {
  build: { name: "Website Development", price: "$600", cadence: "one time" },
  hosting: { name: "Hosting & Maintenance", price: "$75", cadence: "/month" },
  cancellationNote:
    "Hosting & Maintenance is billed monthly with no long-term contract. Cancel anytime — see our Cancellation Policy for the full terms.",
};

export const HERO_FACTS = [
  { label: "One-time build", value: "From $600" },
  { label: "Hosting", value: "$75/mo" },
  { label: "Commitment", value: "Cancel anytime" },
];

export const TRUST_POINTS = [
  "Fixed, upfront pricing",
  "No account managers — work with the builders",
  "Month-to-month hosting, no lock-in",
  "Mobile-first, fast-loading builds",
];

export const INDUSTRIES = [
  "Small Business",
  "Restaurants",
  "Automotive",
  "Contractors",
  "Personal Brands",
  "E-commerce",
  "Portfolios",
  "Landing Pages",
];

/** Social links stay blank until supplied by the studio. */
export const SOCIALS: { name: string; href: string }[] = [
  { name: "Instagram", href: "" },
  { name: "Facebook", href: "" },
  { name: "LinkedIn", href: "" },
  { name: "X", href: "" },
];
